module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7318fc38eeca19704bca37e61c899e86.png";